import { t } from "@redotech/redo-i18n";
import { assertNever } from "@redotech/util/type";

export enum CustomerWidgetTab {
  GENERAL = "general",
  SUPPORT = "support",
  ACCOUNTS = "accounts",
  CHAT_AUTOMATIONS = "chat-automations",
}

export const CUSTOMER_WIDGET_TAB_QUERY = "tab";

export function customerWidgetTabToFriendly(tab: CustomerWidgetTab): string {
  switch (tab) {
    case CustomerWidgetTab.GENERAL:
      return t("General");
    case CustomerWidgetTab.SUPPORT:
      return t("Support");
    case CustomerWidgetTab.ACCOUNTS:
      return t("Accounts");
    case CustomerWidgetTab.CHAT_AUTOMATIONS:
      return t("Chat Automations");
    default:
      return assertNever(tab);
  }
}

const customerWidgetTabs: CustomerWidgetTab[] = [
  CustomerWidgetTab.GENERAL,
  CustomerWidgetTab.SUPPORT,
  CustomerWidgetTab.ACCOUNTS,
  CustomerWidgetTab.CHAT_AUTOMATIONS,
];

export interface GetVisibleCustomerWidgetTabsArgs {
  supportEnabled: boolean;
  customerAccountsEnabled: boolean;
  canUpdateGeneralSettings: boolean;
  canUpdateSupportSettings: boolean;
  canUpdateCustomerAccountsSettings: boolean;
}

export function getVisibleCustomerWidgetTabs({
  supportEnabled,
  customerAccountsEnabled,
  canUpdateGeneralSettings,
  canUpdateSupportSettings,
  canUpdateCustomerAccountsSettings,
}: GetVisibleCustomerWidgetTabsArgs): CustomerWidgetTab[] {
  return customerWidgetTabs.filter((tab) => {
    switch (tab) {
      case CustomerWidgetTab.GENERAL:
        return canUpdateGeneralSettings;
      case CustomerWidgetTab.SUPPORT:
        return supportEnabled && canUpdateSupportSettings;
      case CustomerWidgetTab.ACCOUNTS:
        return customerAccountsEnabled && canUpdateCustomerAccountsSettings;
      case CustomerWidgetTab.CHAT_AUTOMATIONS:
        return supportEnabled && canUpdateSupportSettings;
      default:
        assertNever(tab);
    }
  });
}
